exports = module.exports = require("../../node_modules/_css-loader@0.23.1@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".xform-custom-number-input .ant-input-number {\n  width: 100% !important;\n}\n", ""]);

// exports
